/**
 * Outlined "document with a checkmark" icon used to denote a completed submission
 * on an order (e.g. the completed state shown in the Auth Status column).
 *
 * @param props.width - SVG width (defaults to `16`).
 * @param props.height - SVG height (defaults to `16`).
 * @param props.stroke - Stroke color for the glyph (defaults to green `#008F32`).
 * @returns The rendered file-check SVG icon.
 */
const FileCheckIcon = (props: {
  width?: string;
  height?: string;
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "16"}
    height={props.height || "16"}
    viewBox="0 0 13 15"
    fill="none"
  >
    <path
      d="M11.2135 7.55078V3.75078C11.2135 2.63068 11.2135 2.07062 10.9956 1.6428C10.8038 1.26648 10.4978 0.960515 10.1215 0.768768C9.6937 0.550781 9.13365 0.550781 8.01354 0.550781H3.74687C2.62677 0.550781 2.06672 0.550781 1.63889 0.768768C1.26257 0.960515 0.956609 1.26648 0.764862 1.6428C0.546875 2.07062 0.546875 2.63068 0.546875 3.75078V10.6841C0.546875 11.8042 0.546875 12.3643 0.764862 12.7921C0.956609 13.1684 1.26257 13.4744 1.63889 13.6661C2.06672 13.8841 2.62677 13.8841 3.74687 13.8841H5.88021M7.21354 6.55078H3.21354M4.54687 9.21745H3.21354M8.54687 3.88411H3.21354M7.54687 11.8841L8.88021 13.2174L11.8802 10.2174"
      stroke={props.stroke || "#008F32"}
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FileCheckIcon;
